<template id="map-template">
  <div class="homeview-messagecenter-data">
    <div class="header">
      <span class="header-title title2">最近消息</span>
    </div>
    <div class="table-chart">
      <el-table
        :data="tableData"
        ref="multipleTable"
        @row-click="showDetail"
        border
        style="width: 100%"
        :row-style="{ height: '4rem' }"
        fixed
        :show-header="false"
      >
        <el-table-column
          prop="entityTypeTranslated"
          label="消息类型"
          min-width="26%"
        >
          <template slot-scope="scope">
            <el-tag type="danger" size="mini">{{
              scope.row.entityTypeTranslated
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="消息时间"
          min-width="37%"
          :formatter="formatDate"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="messageIntro"
          label="消息内容"
          min-width="37%"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- 1：已查看/2：未查看 -->
            <i class="red-dot" v-if="scope.row.viewStatus == 2"></i>
            <span>{{ scope.row.messageIntro }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer" style="padding: 10px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="prev, pager, next"
        background
        :total="total"
      ></el-pagination>
    </div>
    <MsgDetail
      v-if="isShow"
      :isShow="isShow"
      :msgId="msgId"
      @closeMsgDetail="closeMsgDetail"
    ></MsgDetail>
  </div>
</template>

<script>
import { getMessageList } from "@/api/src/message";
import MsgDetail from "./MsgDetail.vue";
export default {
  name: "HomeViewMessageData",
  componentName: "HomeViewMessageData",
  components: {
    MsgDetail,
  },
  data() {
    return {
      tableData: [], //表格数据
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      isShow: false,
      msgId: "",
      timer: null,
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.getList();
    }, window.$config.app.intervalTime || 300000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // 消息列表
    getList() {
      getMessageList(this.queryParams).then((res) => {
        this.tableData = res.rows;
        this.total = res.total;
      });
    },
    // 格式化消息时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy/MM/dd hh:mm");
    },
    // 详情弹出
    showDetail(row) {
      this.msgId = row.id;
      this.isShow = true;
    },
    // 详情关闭
    closeMsgDetail() {
      this.isShow = false;
      this.getList();
    },
    // 点击每页显示的条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.red-dot {
  position: absolute;
  width: 0.6rem;
  height: 0.6rem;
  background: #e7494b;
  border-radius: 50%;
  right: 0.5rem;
  top: 1rem;
}
</style>